export default "https://cdn-static.gokick.com/assets/c3e2404f2f1be1cd3bf75e8d7804f871d91db3b2/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";